
  <div
    class="pill"
    [class.hashed]="hashed"
    [class.pill--clickable]="clickable"
    [style.background-color]="backgroundColor"
    [style.borderColor]="hasBorder ? color : 'transparent'"
    [style.cursor]="clickable ? 'pointer' : 'default'"
    (click)=" clickable ? onClick.emit($event) : null"
    [style.maxWidth]="maxWidth"
  >
    <app-svg-icon *ngIf="icon" [icon]="icon" [color]="color" [size]="16" [strokeWidth]="1"></app-svg-icon>
    <div class="pill-text" [style.color]="color">{{ text }}</div>
    <button
      *ngIf="removable"
      type="button"
      class="pill-remove"
      [style.color]="color"
      [attr.aria-label]="'Remove ' + text"
      (click)="$event.stopPropagation(); onRemove.emit($event)"
    >
      ×
    </button>
  </div>

